import { render, staticRenderFns } from "./growthChart.vue?vue&type=template&id=60943319"
import script from "./growthChart.vue?vue&type=script&lang=js"
export * from "./growthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports